import { styled } from "@tino-frontend/coreui";
const SelectMockRoot = styled("div")(({ theme }) => ({
  position: "fixed",
  zIndex: theme.zIndex.appBar,
  left: "0",
  width: "100%",
  height: "415px",
  backgroundColor: "#000",
  padding: "10px",
  color: "#fff"
}));
const Icon = styled("div")(() => ({
  backgroundColor: "#000",
  margin: "-35px 0 0 0px",
  width: "25px",
  height: "25px",
  transform: "rotate(90deg)",
  fontSize: "19px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer"
}));
const Wrapper = styled("div")(() => ({
  overflow: "auto",
  height: "312px",
  paddingBottom: 80
}));
const Form = styled("form")(() => ({
  display: "flex",
  flexWrap: "wrap"
}));
const EachMock = styled("div")(() => ({
  width: "180px",
  padding: "0 5px 15px 0"
}));
const Label = styled("label")(() => ({
  fontSize: "14px"
}));
const Hr = styled("hr")(() => ({
  borderColor: "#727272"
}));
const Buttons = styled("div")(() => ({
  backgroundColor: "#484848",
  padding: "5px"
}));
const Tabs = styled("div")(() => ({
  display: "flex",
  padding: "10px 0px"
}));
const TabLink = styled("a")(({ active }) => ({
  color: "#fff",
  fontSize: "14px",
  padding: "10px 20px",
  cursor: "pointer",
  borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
  width: "100%",
  ":hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  ...active && {
    backgroundColor: "rgba(255, 255, 255, 0.3)"
  }
}));
const TabContent = styled("div")(
  ({ selected }) => ({
    display: "none",
    ...selected && {
      display: "block"
    }
  })
);
const Code = styled("pre")(({ selected }) => ({
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  border: "1px solid rgba(255, 255, 255, 0.5)",
  borderRadius: "5px",
  marginBottom: "10px",
  padding: "5px",
  maxWidth: "100%",
  maxHeight: 300,
  overflow: "hidden",
  height: 30,
  transition: "all 0.3s ease-in-out",
  ...selected && {
    height: "auto",
    overflow: "auto"
  }
}));
const Textarea = styled("textarea")(() => ({
  width: "100%",
  display: "block",
  marginBottom: "10px",
  maxWidth: "100%",
  height: 100
}));
export {
  Buttons,
  Code,
  EachMock,
  Form,
  Hr,
  Icon,
  Label,
  SelectMockRoot,
  TabContent,
  TabLink,
  Tabs,
  Textarea,
  Wrapper
};
//# sourceMappingURL=select-mock.styles.js.map
